import { types } from 'mobx-state-tree';

export default types.model('ItemSummary', {
  title: types.string,
  seller: types.maybe(types.union(types.null, types.string)),
  image: types.string,
  alias: types.string,
  location: types.string,
  created_at: types.string,
  price: types.number,
});
